import { render, staticRenderFns } from "./SystemEdit.vue?vue&type=template&id=06c1a3be&scoped=true&"
import script from "./SystemEdit.vue?vue&type=script&lang=js&"
export * from "./SystemEdit.vue?vue&type=script&lang=js&"
import style0 from "./SystemEdit.vue?vue&type=style&index=0&id=06c1a3be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1a3be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c1a3be')) {
      api.createRecord('06c1a3be', component.options)
    } else {
      api.reload('06c1a3be', component.options)
    }
    module.hot.accept("./SystemEdit.vue?vue&type=template&id=06c1a3be&scoped=true&", function () {
      api.rerender('06c1a3be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/music/comp/Lesson/SystemEdit.vue"
export default component.exports